import api from '@/api/api';

export default {
  getAll(demoDayId) {
    const path = `/api/v1/demo_day/demo_days/${demoDayId}/meetings`;

    return api({
      method: 'get',
      url: path,
    });
  },
  create(demoDayCompanyId, { motive }) {
    const path = `/api/v1/demo_day/demo_day_companies/${demoDayCompanyId}/meetings`;

    return api({
      method: 'post',
      url: path,
      data: { demoDayCompanyMeeting: { motive } },
    });
  },
};
